import {
  fetchRequest,
  reactQueryDelete,
  reactQueryPost,
  reactQueryPut,
} from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

export interface AddMembersParams {
  body: Record<string, unknown>;
  spaceGroupId: number;
}

interface RestoreParams {
  id: number;
}

const index = <T = unknown>() =>
  fetchRequest<T>(internalApi.spaceGroups.index(), {
    method: "GET",
  });

const addMembers = ({ spaceGroupId, body }: AddMembersParams) =>
  reactQueryPost(
    internalApi.spaceGroups.addMemberToSpaceGroup({ spaceGroupId }),
    body,
  );

const create = (payload: Record<string, unknown>) =>
  reactQueryPost(internalApi.spaceGroups.create(), payload);

const update = (id: number, payload: Record<string, unknown>) =>
  reactQueryPut(internalApi.spaceGroups.update({ id }), payload);

const destroy = (id: number, payload?: Record<string, unknown>) =>
  reactQueryDelete(internalApi.spaceGroups.destroy({ id }), payload);

const restore = ({ id }: RestoreParams) =>
  reactQueryPost(internalApi.spaceGroups.restore({ id }));

export const spaceGroupApi = {
  index,
  addMembers,
  create,
  update,
  destroy,
  restore,
};
